import { createFileRoute } from '@tanstack/react-router'
import { ApikeyScreen } from '@web/app/features/api_key'
import { Key } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/security/api-keys')({
  component: ApikeyScreen,
  staticData: {
        metaRoute: {
          title: 'API Key',
          order: 2,
          icon: Key,
        },
  },
})
